import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { key: 0 }

import { computed } from "vue";

type Props = {
  progress: number;
  warning?: boolean;
  color?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireProgressBar',
  props: {
    progress: {},
    warning: { type: Boolean },
    color: {}
  },
  setup(__props: any) {

const props = __props;

const warning = computed(() => props.warning);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (warning.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "bg-progress-bg-warning h-[5px] w-full" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["h-[5px]", `${__props.progress === 100 ? 'bg-[#4D48A6]' : 'bg-progress-background'}`]),
          style: _normalizeStyle({ width: __props.progress + '%' })
        }, null, 6))
  ]))
}
}

})